export default {"src":"/_next/static/image/public/images/ic_notified.6ada2466b2cb18b62a8c1122f9a75702.svg","height":40,"width":40};